<!-- eslint-disable vue/no-unused-components -->
<!-- eslint-disable vue/no-unused-components -->
<!-- eslint-disable vue/valid-template-root -->
<!-- eslint-disable no-mixed-spaces-and-tabs -->

<template>
	<div>
    <div class="video-banner">
      <div class="container flex">
        <!-- 全屏背景图 -->
        <div class="background-image">
          <img src="~@/assets/image/videotext.png" />
        </div>

        <!-- 右侧悬浮视频 -->
        <video class="side-video"  poster="~@/assets/image/videobj.png" autoplay loop muted playsinline >
          <source src="~@/assets/image/indexvideo2.mp4" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
		<div class="hj-banner HJ05-banner1-box">
			<div id="HJ05-banner2">
				<div class="banner2_swiper">
					<div class="swiper-wrapper">
						<div class="swiper-slide HJ-banner-item">
							<a href="javascript:void(0)"><img src="~@/assets/image/banner/index-0.jpg" /></a>
						</div>
						<div class="swiper-slide HJ-banner-item">
							<a href="javascript:void(0)"><img src="~@/assets/image/banner/index-1.jpg" /></a>
						</div>
						<div class="swiper-slide HJ-banner-item">
							<a href="javascript:void(0)"><img src="~@/assets/image/banner/index-2.jpg" /></a>
						</div>
						<div class="swiper-slide HJ-banner-item">
							<a href="javascript:void(0)"><img src="~@/assets/image/banner/index-3.jpg" /></a>
						</div>
					</div>
					<div class="swiper-pagination hj-banner-pagination"></div>
					<div class="swiper-button-next hj-banner-next"><i class="fa fa-angle-right"></i></div>
					<div class="swiper-button-prev hj-banner-prev"><i class="fa fa-angle-left"></i></div>
				</div>
			</div>
		</div>


<!--	<div class="body_dz">-->
<!--		<div class="container border-box">-->
<!--			<h3>在线定制您的灯箱展位</h3>-->
<!--			<h4>用个性化展示你独特的风格<br/>模块化SEG灯箱展位！</h4>-->
<!--			<p>这些尖端的显示器提供令人惊叹的图形和轻松的设置，使它们成为为您的下一次贸易展会或活动提供完美选择。</p>-->
<!--			<div class="body_dz_btn">-->
<!--				<router-link :to="{name:'customizedservice'}">前往定制</router-link>-->
<!--			</div>-->
<!--		</div>-->
<!--		<img src="~@/assets/image/index_bg01.png" width="100%"/>-->
<!--	</div>-->

    <div class="body_mkhdx">
      <div class="container flex">
        <div class="w50">
			<img src="~@/assets/image/mkhdx.png">
        </div>
        <div class="body_mkhdx-products w50 flex flex-wrap">

          <div class="product_item w50" v-for="(item) in importantProds" :key="item.id">
            <img :src="item.image_url" />
            <div class="product_title">
				<span>SEG 120mm</span>
				<br/>
				<span>{{ item.nameShow }}</span>
			</div>
            <router-link :to="'detail/'+item.id" class="product_order">
            <div class="flex product_order_group">
              <div class="shipping_icon"><img src="~@/assets/image/shippingicon.png"> </div>
              <div class="shipping_btn">在线下单</div>
            </div>
            </router-link>
          </div>

        </div>
      </div>
    </div>

    <div class="body_dxctj">
		<div class="container">
			<div class="dxctj_title flex align-content-center">
				<img src="~@/assets/image/protitle.png"/>
			</div>
			<div class="dxctj_list">
				<div class="dxctj_item dxctj_item-first"><img src="~@/assets/image/dxctj_lt.jpg"/></div>
				<div class="dxctj_item dxctj_item-head_width" v-for="item in boxsizeList.width" :key="item" >
					<img :src="require('@/assets/image/dxctj-' + item + '.jpg')" />
				</div>
				<div class="dxctj_item" 
					:class="{
						'dxctj_item-head_height': (i % 7 == 0),
						'dxctj_item-has_order': (i % 7 != 0),
					}" 
					v-for="(item, i) in tableBody" 
					:key="i">
					<p>{{ item.name }}</p>
					<router-link :to="item.routerName" class="dxctj_item-order" v-if="i % 7 != 0">
            <div class="flex product_order_group">
              <div class="shipping_icon"><img src="~@/assets/image/shippingicon.png"> </div>
              <div class="shipping_btn">在线下单</div>
            </div>
          </router-link>
				</div>
			</div>
			<div class="dxctj_tips"> 
				<p class="dxctj_tips-cn">*如果我们的标准尺寸不符合您的要求，请不要担心！根据您的特定需求定制尺寸，请与我们联系。</p>
				<p class="dxctj_tips-en">*If our standard sizes don’t meet your requirements, don’t worry! Contact us for custom sizes tailored to your specific needs.</p>
			</div>
		</div>
    </div>

<!--	<div class="index_main2 border-box"> -->
<!--		<div class="container">-->
<!--			<div class="index_main2-title">-->
<!--				<img src="~@/assets/image/index_main2-title.png"/>-->
<!--			</div>-->
<!--			<div class="index_main2-main">-->
<!--				<img src="~@/assets/image/index_main2-left.png"/>-->
<!--				<img src="~@/assets/image/index_main2-icon.png"/>-->
<!--				<img src="~@/assets/image/index_main2-right.png"/>-->
<!--			</div>-->
<!--		</div>-->
<!--	</div>-->
	
	<div class="index_main3 border-box">
		<div class="container">
			<div class="index_main3-title">
				<img src="~@/assets/image/index_main3-title.png"/>
			</div>
			<p class="index_main3-desc">在基础展位上，你可以再选择一些模组单品设计组合在展位中，这些组合提供各种样式和尺寸，以满足您的展位设计需求</p>
			<div class="index_main3-main">
				<!-- {{ goodsList }} -->
				 <!-- {{ main3Prods }} -->
				 <!-- {{ allcatList }} -->
				<div class="index_main3-tab">
					<button type="button" 
						class="index_main3-tab-item" 
						:class="{'active' : showProdInMain3 === 'all'}"
						@click="showProdInMain3 = 'all'">全部</button>
					<button type="button" 
						class="index_main3-tab-item" 
						v-for="(item) in main3Tab" 
						:key="item.id"
						:class="{'active' : showProdInMain3 === item.id}" 
						@click="showProdInMain3 = item.id">
						<span>{{ item.name }}</span>
					</button>
				</div>
				<div class="index_main3-list">
					<div class="index_main3-item" v-for="item in main3Prods" :key="item.id">
						<img :src="item.image_url" :alt="item.name">
						<router-link :to="`/detail/${item.id}`" class="index_main3-item_button">
              <div class="flex product_order_group">
                <div class="shipping_icon"><img src="~@/assets/image/shippingicon.png"> </div>
                <div class="shipping_btn">在线下单</div>
              </div>
            </router-link>
					</div>
				</div>
        <router-link :to="`/search`" >
        <div class="pro_more_btn">更多方案</div>
        </router-link>
			</div>
		</div>
	</div>
  <div class="part3">
    <img src="~@/assets/image/part3bj.png" />
    <div class="container containerabs">
      <img src="~@/assets/image/part3text.png">
      <router-link :to="{name:'customizedservice'}">
        <div class="btn">前往定制</div>
      </router-link>
    </div>
  </div>

	<div class="index_bottom">
    <img class="part3top" src="~@/assets/image/part3top.png" />
		<img src="~@/assets/image/index_bottom.png" />
    <img class="part3bottom" src="~@/assets/image/part3bottom.png" />
	</div>

    <div class="part4">
      <img src="~@/assets/image/part4bg.png">
      <div class="container">
        <div class="container containerabs">
          <div class="w50">
            <img src="~@/assets/image/part4txt.png">
            <router-link :to="{name:'about'}">
              <div class="btn">了解更多</div>
            </router-link>
          </div>
        </div>

        </div>
      </div>
    </div>

	</div>
</template>
<style>
	.HJ-banner-item img{
		width: 100%;
	}
	.bg03_item_icon:hover{
		transform: scale(1.2,1.2);
		transition: all 0.3s;
	}
	.body_mkhdx-products{
		gap: 40px 0;
	}
	.product_item img{
		max-width: 100%;
		max-height: 230px;
		/* transform: translateX(-90px); */
	}
	.index_main3-tab{
		display: flex;
		justify-content: center;
		gap: 100px;
		padding-bottom: 56px;
	}
	.index_main3-tab-item{
		padding: 6px 20px;
		border-radius: 50px;
		color: var(--main_color_index);
		border: 1px solid var(--main_color_index);
		font-size: 21px;
		background: none;
		cursor: pointer;
		transition: .3s all;
	}
	.index_main3-tab-item:hover, 
	.index_main3-tab-item.active{
		background: var(--main_color_index);
		color: #fff;
	}
</style>
<script>
	// import AllClassify from "@/components/common/AllClassify.vue";
	import Swiper from 'swiper';
	// import { goodsList } from "../config/http";

	export default {
		data() {
			return {
				allClassifyData: [], //所有商品分类
				bannerArr: [],
				deallist: [],
				hoverIndex: 0,
				centerDialogVisible: false,
				allcatList: [],
				goodsList: {},
				couponList:[],
				boxsizeList:{
					width: [1000, 2000, 3000, 4000, 5000, 6000 ],
					height: [2000, 2250, 2500]
				},
				showProdInMain3: 'all'
			};
		},
		computed: {
			importantProds: function() { 
				let res = [];
				const thisProds = this.goodsList[69] ? this.goodsList[69].slice(0, 4) : [];
				
				if (thisProds.length > 0) {
					res = thisProds.map(item => {
						const isSizeFormat = /^\d+[xX]\d+$/i.test(item.name);
						// console.log(item);
						const infoProd = {
							...item,
							nameShow: isSizeFormat ? item.name + '灯箱' : item.name
						};
						return infoProd;
					});
				}
				return res;
			},
			tableBody: function() {
				const res = [];
				this.boxsizeList.height.forEach(height => {
					res.push({name: height});
					this.boxsizeList.width.forEach(width => {
						const name = `${width}X${height}`;
						const thisProds = this.goodsList[69] ? this.goodsList[69] : [];
						let id = '';
						if(thisProds.length > 0){
							// console.log(thisProds);
							const thisProd = thisProds.find(item => {

                const widthAndHeight = item.name.split(/x|X/);
// console.log(widthAndHeight, width, height);


          // 从完整名称中提取宽度值，例如从"模块化灯箱1000X2000"中提取1000
          let extractedWidth = null;
          if (item.name) {
            const widthMatch = item.name.match(/(\d+)\s*[xX]/i);
            if (widthMatch && widthMatch[1]) {
              extractedWidth = widthMatch[1];
            }
          }

          return extractedWidth == width;

							});
							id = thisProd ? thisProd.id : '';
						}
						res.push({
							name,
							routerName : id ? `/detail/${id}` : '/search',
						});
					})
				})
				return res;
			},
			main3Tab:  function() {
				if (this.allcatList && this.allcatList[0] && this.allcatList[0].child) {
          return this.allcatList[0].child.filter(item => ![68, 69].includes(item.id));

				}
				return [];
			},
			main3Prods:  function() {
				if (this.goodsList) {
					const goods = [
            ...(this.goodsList[63] || []),
            ...(this.goodsList[64] || []),
            ...(this.goodsList[65] || [])
          ];
					const filterId = this.showProdInMain3;
					if(filterId === 'all'){
						return goods;
					}else{
						return goods.filter(item => item.goods_cat_id === filterId)
					}
				}
				return []
			}
		},
		name: "Home",
		// components: {
		// 	AllClassify
		// },
		beforeRouteEnter(to, from, next) {
			next(vm => {
				// 通过 `vm` 访问组件实例,将值传入fromPath
				vm.fromPath = from.path
				console.log("path", vm.fromPath);
				if (vm.fromPath == "/login" && vm.couponList.length > 0) {
					vm.centerDialogVisible = true
				}
			})
		},
		mounted() {
			this.getHomeSlider();
			this.$nextTick(() => {
				new this.$wow.WOW().init();
			});

			new Swiper('.banner2_swiper', {
				loop: true,
				pagination: '.swiper-pagination',
				//如果需要自动切换海报
				autoplay: 4000 //时间 毫秒

			});
			new Swiper('.swiper-container', {
				loop: true,
				// 如果需要前进后退按钮
				nextButton: '.swiper-button-next',
				prevButton: '.swiper-button-prev',
				//如果需要自动切换海报
				autoplay: 2000 //时间 毫秒

			});

			let galleryTop = new Swiper('.body_bg05_swiper_top', {
				slidesPerGroup: 1,
				slidesPerView: 1,
				nextButton: '.body_bg05_swiper_next',
				prevButton: '.body_bg05_swiper_prev',
				observer: true, //修改swiper自己或子元素时，自动初始swiper
				observeParents: true, //修改swiper的父元素时,自动初始swiper

			});
			let galleryThumbs = new Swiper('.body_bg05_swiper', {
				slidesPerGroup: 1,
				slidesPerView: 1,
				grabCursor: true,

				observer: true,
			});
			galleryTop.params.control = galleryThumbs;
			galleryThumbs.params.control = galleryTop;
		},
		created() {
			this.categories();
		},
		methods: {
			getGoodsList(id) {
				console.log("获取商品列表");
				let obj = {
					page: 1,
					where: {
						cat_id: id
					},
					limit: 60
				};
				if (obj.where) {
					obj.where = JSON.stringify(obj.where);
				}
				let that = this;
				this.$api.goodsList(obj).then(res => {
					console.log("res", res);
					if (res.status) {

						that.$set(that.goodsList, id, res.data.list);
						console.log("that.goodsList", that.goodsList);
					}
				});
			},
			//获取分类
			categories() {
				let that = this;
				this.$api.categories().then(res => {
					if (res.status) {
						this.allcatList = res.data;
						if (this.allcatList && this.allcatList[0] && this.allcatList[0].child) {
							this.allcatList[0].child.forEach(function(v) {
								that.getGoodsList(v.id);
							})
						}
					}
				});
			},
			// /点击
			swiperClick(v) {
				// type 1 url 直接跳转
				// 2 商品
				//  3 文章
				// 4  文章分类
				// 5 智能表单
				// window.open('https://www.baidu.com','_blank')
				if (v.type == 1) {
					window.open(v.val, '_blank')
					return
				}

				if (v.type == 2) {
					this.$router.push({
						path: `detail/${v.id}`,
					})
					return
				}
			},
			getLoftData() {
				this.$api.homeLoftData().then(res => {
					if (res.status) {
						this.loftData = res.data;
						console.log("loftData", this.loftData);
					}
				});
			},
			//获取首页banner轮播
			getHomeSlider() {
				// let data={
				//   code: "pc_home_slider"
				// }
				let data = {
					code: "tpl1_slider"
				};
				this.$api.slider(data).then(res => {
					if (res.status) {
						this.bannerArr = res.data.list;
					}
				});
			}
		},
		deactivated() {
			this.centerDialogVisible = false;
		}
	};
</script>
